export function prepareInvoiceListFilterParams(filters: IInvoiceFilters, pagination: MySsPagination) {
  const filterParams = prepareQueryParams(filters, pagination);

  const filteredField = INVOICE_FILTER_OPTIONS_ENUM[filterParams.filteredField as keyof typeof INVOICE_FILTER_OPTIONS_ENUM];

  const result = {
    ...filterParams,
    filteredField,
  };

  return removeEmptyFields<any>(...Object.keys(result))(result);
}

export function prepareInvoiceReturn(data: any, isList = false) {
  if (isList) {
    return {
      invoiceList: adaptInvoiceListFromAPI(data.items),
      pagination: data.pagination ?? { ...PAGINATION },
    };
  }

  return adaptInvoiceFromAPI(data);
}

export function prepareInvoiceFilterQueryParams(mySsFilterParamsResult: IInvoiceFilterParams<IInvoiceFilterKeys>): IInvoiceFilterParams {
  return {
    ...mySsFilterParamsResult,
    filteredField: INVOICE_FILTER_OPTIONS_ENUM[mySsFilterParamsResult.filteredField],
    productType: INVOICE_PRODUCT_TYPE_ENUM[mySsFilterParamsResult.productType],
    invoiceStatus: INVOICE_STATUS_ENUM[mySsFilterParamsResult.invoiceStatus]
  };
}
